module.exports = __webpack_public_path__ + "img/lock.352d684f.png";